module.exports = __webpack_public_path__ + "assets/webgl/Assets_4_base_color.jpg.astc.a5777d47.ktx";